// NOMBASE — Legacy slug rewrite helper
//
// When we standardised detail-page URL slugs to canonical plural
// (e.g. `/network/supplier/:id` → `/network/suppliers/:id`), we kept
// the old singular paths registered as React Router routes so that
// external bookmarks, email links, and webhook callbacks keep working.
//
// Each legacy route renders this component to perform a transparent
// SPA-level redirect. It preserves the current path's dynamic segments
// by string-replacing the static prefix only, and also carries over
// any `?search` and `#hash` so deep-link state survives the rewrite.
//
// Usage:
//   <Route
//     path="/network/supplier/:supplierId"
//     element={<LegacyRewriteRedirect from="/network/supplier/" to="/network/suppliers/" />}
//   />
//
// Param-less swaps just pass equal-length strings; param-bearing swaps
// rely on the fact that React Router has already matched the route
// before this component renders, so `window.location.pathname` holds
// the *real* URL the user typed, not the route template.
import { Navigate } from 'react-router-dom';

export const LegacyRewriteRedirect = ({ from, to }) => {
  const { pathname, search, hash } = window.location;
  const next = pathname.replace(from, to) + search + hash;
  return <Navigate to={next} replace />;
};

export default LegacyRewriteRedirect;
